import { styled } from '@mui/system';
import { TextField as TextFieldMUI, Stack as StackMUI} from  "@mui/material";
import { theme } from 'oems/theme';

export const TextField = styled(TextFieldMUI)`
  padding-right: 10px;
  margin: 10px;
  background-color: ${({ theme }) => theme.palette.background.paper};
`;

export const Label = styled('div')`
    font-weight: 400;
    font-size: 14px;
    line-height: 150%;
    color: ${theme.palette.secondary.main};
`;
export const Stack = styled(StackMUI)` 
  padding: 10px;
`;

